import { useHistory } from 'react-router-dom';
import { Header } from '../../components/common/Header';
import {
  PaymentLinkFilters,
  usePaymentLinkFilters,
} from './PaymentLinkFilters';
import { PaymentLinkTable } from './PaymentLinkTable';

export function PaymentLinksList(): JSX.Element {
  const history = useHistory();
  const [filters] = usePaymentLinkFilters();

  const onCreateClick = () => {
    history.push('/payment-links/new');
  };

  return (
    <>
      <Header
        title="Link de pago"
        primaryButton={{
          onClick: onCreateClick,
          text: 'Crear nuevo',
        }}
      />
      <PaymentLinkFilters filters={filters} />
      <PaymentLinkTable
        filters={filters}
        trackingContext="payment link screen"
      />
    </>
  );
}
